import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCalendarAlt,
  faUserCheck,
  faUserTimes,
  faClock
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import './StudentPtm.css';

const StudentPTM = ({studentId}) => {
  const [ptms, setPtms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPTMs = async () => {
      try {
        console.log(studentId);
        setLoading(true);
        const token = localStorage.getItem('userData');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/students/ptm/${studentId}`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );
        setPtms(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching PTMs:', err);
        setError('Failed to load PTM data');
        setLoading(false);
      }
    };

    fetchPTMs();
  }, [studentId]);

  const formatDateTime = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric', 
      hour: '2-digit', 
      minute: '2-digit' 
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  return (
    <div className="studentptm-container">
      <h2 className="studentptm-header">Parent-Teacher Meetings</h2>
      
      {loading ? (
        <div className="studentptm-loading">Loading PTM data...</div>
      ) : error ? (
        <div className="studentptm-error">{error}</div>
      ) : ptms.length === 0 ? (
        <div className="studentptm-empty">No PTM records found</div>
      ) : (
        <div className="studentptm-list">
          {ptms.map((ptm) => (
            <div key={ptm.Id} className="studentptm-card">
              <div className="studentptm-card-header">
                <div className="studentptm-date">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  <span>{formatDateTime(ptm.DateOfPtm)}</span>
                </div>
                <div className={`studentptm-status ${ptm.Done === 1 ? 'available' : 'not-available'}`}>
                  <FontAwesomeIcon icon={ptm.Done === 1 ? faUserCheck : faUserTimes} />
                  <span>{ptm.Done === 1 ? 'Parents Available' : 'Parents Not Available'}</span>
                </div>
              </div>
              
              { ptm.DateOfPtmDone && (
                <div className="studentptm-duration">
                  <FontAwesomeIcon icon={faClock} />
                  <span>Meeting Submit:  {formatTime(ptm.DateOfPtmDone)}</span>
                </div>
              )}
              
              <div className="studentptm-details">
                <h4>Discussion Details:</h4>
                <p>{ptm.Details || 'No details provided'}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentPTM;